<template>
  <i
    class="hkfi-back fs-12 bold zIndex9999"
    @click="$emit('handleBackClick')"
  ></i>
</template>

<script>
import LocalStorageFunc from "../helpers/localStorageFunc";
export default {
  name: "BackArrow",
  components: {},
  data() {
    return {
      mobileNo: LocalStorageFunc.getUserMobileNo() || "",
    };
  },
  mounted() {},
  methods: {},
  computed: {},
};
</script>
